import gallery from "../data/PhuketSkypark/gallery";
import concept from "../data/PhuketSkypark/concept";
import masterplan from "../data/PhuketSkypark/masterplan";
import sitePlan from "../data/PhuketSkypark/sitePlan";
import residence from "../data/PhuketSkypark/residence";
import destination from "../data/PhuketSkypark/destination";
import sanctuaryClub from "../data/PhuketSkypark/sanctuaryClub";

const fetchGalleryApi = () => {
  return Promise.resolve(gallery);
};

const fetchConceptApi = () => {
  return Promise.resolve(concept);
};

const fetchMasterPlanApi = () => {
  return Promise.resolve(masterplan);
};

const fetchSitePlanApi = () => {
  return Promise.resolve(sitePlan);
};

const fetchResidenceApi = () => {
  return Promise.resolve(residence);
};

const fetchDestinationApi = () => {
  return Promise.resolve(destination);
};

const fetchSanctuaryClubApi = () => {
  return Promise.resolve(sanctuaryClub);
};

export {
  fetchGalleryApi,
  fetchConceptApi,
  fetchMasterPlanApi,
  fetchSitePlanApi,
  fetchResidenceApi,
  fetchDestinationApi,
  fetchSanctuaryClubApi
};



// WEBPACK FOOTER //
// ./src/services/phuket-skypark.js